import { Box, Typography } from '@chronosphereio/chrono-ui';
import { Fragment } from 'react';

/**
 *
 * Split series name into parts and highlight which match regex pattern input
 */
export function RegexMatchDisplay({ name, regex }: { name: string; regex: RegExp }) {
  if (!name || !regex) {
    return null;
  }
  const parts = name.split(regex);
  return (
    <Typography
      variant="code"
      sx={(theme) => ({
        color: theme.palette.mode === 'light' ? theme.palette.text.inversePrimary : theme.palette.text.primary,
      })}
    >
      {parts.map((part, index) => (
        <Fragment key={`matched-part-${index}`}>
          {index > 0 && (
            <Box
              component="span"
              sx={(theme) => ({
                backgroundColor: theme.palette.status.info.highContrast,
                color: theme.palette.text.inversePrimary,
              })}
            >
              {name.match(regex)?.[index - 1]}
            </Box>
          )}
          {part}
        </Fragment>
      ))}
    </Typography>
  );
}
